import {default as versionFile} from './version.json';

export const environment = {
  appHost: 'https://darwins-reisen.de',
  appName: 'darwins-reisen.de',
  buchungEnabled: true,
  firebase: {
    apiKey: 'AIzaSyB52R3tsbdTNY_YEE-ABInMKaDtQkLVYrY',
    authDomain: 'darwins-reisen.firebaseapp.com',
    databaseURL: 'https://darwins-reisen.firebaseio.com',
    projectId: 'darwins-reisen',
    storageBucket: 'darwins-reisen.appspot.com',
    messagingSenderId: '851914556'
  },
  functionsURL: 'https://us-central1-darwins-reisen.cloudfunctions.net',
  paypalEnv: 'production',
  paypalPlusMode: 'live',
  production: true,
  sentry: {
    dsn: 'https://5f6a563888d846d5b397fea2b752f603@sentry.io/2155087',
    project: 'darwins-reisen-webui',
    version: versionFile.version,
    showReportDialog: false,
  },
  signInEnabled: true
};
